module.exports = __webpack_public_path__ + "assets/img/6_455_big.2291e576.jpg";